import React, { useEffect, useState } from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import BASE_API_URL from "../../apis/index";
import axios from "axios";
import { Button, Link } from "@mui/material";
import styled from "styled-components";

export default function CompServicesSectionCRO({ compId, compName, compTypes }) {

  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchService() {
      try {

        setLoading(true);

        const authToken = localStorage.getItem("authToken");

        const res = await axios.get(
          `${BASE_API_URL}/api/seller/company/services/cro/${compId}`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        if (res.data && Object.keys(res.data).length > 0) {
          setService(res.data);
        } else {
          setService(null);
        }

      } catch (err) {
        console.error("Failed to fetch services", err);
        setService(null);
      } finally {
        setLoading(false);
      }
    }

    if (compId) fetchService();

  }, [compId]);


  /* ---------- Wait until loading finishes ---------- */

  if (loading) return null;


  /* ---------- No CRO Service ---------- */

  if (!service) {
    return (
      <div className='py-md-5 p-4 bg-light my-4 rounded-4 d-flex align-items-center justify-content-between pb-3 border-bottom'>
        <h4 className='fw-normal txt_color_primary'>
          Services - Contract Research Organisation
        </h4>

        <Link href={`/user-cro-service-register?compId=${compId}&compName=${compName}&types=${encodeURIComponent(JSON.parse(compTypes).join(','))}`}>
          <Button variant="outlined" color="primary" size="medium">
            Register CRO Service
          </Button>
        </Link>
      </div>
    );
  }


  /* ---------- Render Service ---------- */

  return (
    <CompCROServicesSectionWrapper className="py-md-5 p-5 rounded-5 bg-light my-5">

      <div className="border rounded-4 overflow-hidden">

        {/* Header */}

        <div className='d-flex align-items-center justify-content-between px-3 py-4 border-bottom'>

          <h5 className="txt_color_primary fw-medium">
            Services - Contract Research Organisation
          </h5>

          <Link href={`/user-cro-service-edit?servId=${service.id}&compId=${service.company_id}&compName=${compName}`}>
            <Button variant="outlined" size="small">
              Edit Service
            </Button>
          </Link>

        </div>


        {/* Service Catalog */}

        {Array.isArray(service?.service_catalog) &&
          service.service_catalog.length > 0 && (

            <Row label="Service Catalog:">
              {service.service_catalog.map((item, i) => (
                <div className="Pill" key={i}>{item}</div>
              ))}
            </Row>

          )}


        {/* Geographic Reach */}

        {Array.isArray(service?.geographic_reach) &&
          service.geographic_reach.length > 0 && (

            <Row label="Geographic Reach:">
              {service.geographic_reach.map((item, i) => (
                <div className="Pill" key={i}>{item}</div>
              ))}
            </Row>

          )}


        {/* Employee Count */}

        {service?.employee_count && (
          <Row label="No of employees in organization:">
            {service.employee_count}
          </Row>
        )}


        {/* QMS Status */}

        {service?.qms_status && (

          <Row label="QMS Status:">

            <div className="Pill">
              {service.qms_status === "yes" ? "Yes" : "No"}
            </div>

            {service.qms_status === "yes" && service?.qms_file && (

              <Button
                variant="outlined"
                color="warning"
                startIcon={<PictureAsPdfIcon />}
                href={`${BASE_API_URL}/uploads/user_srvc_docs/${service.qms_file}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  textTransform: "none",
                  borderRadius: "5px",
                  padding: "5px 12px",
                  fontSize: "14px",
                }}
              >
                View File
              </Button>

            )}

          </Row>

        )}


        {/* SOP Following */}

        {service?.sop_following && (

          <Row label="SOP Following:">

            <div className="Pill">
              {service.sop_following === "yes" ? "Yes" : "No"}
            </div>

          </Row>

        )}


        {/* Past Audit Date */}

        {service?.past_audit_date && (

          <Row label="Past Audit Date:">
            {new Date(service.past_audit_date).toLocaleDateString()}
          </Row>

        )}


        {/* Compliance Statement */}

        {service?.compliance_statement && (

          <Row label="Compliance Statement:">
            {service.compliance_statement}
          </Row>

        )}

      </div>

    </CompCROServicesSectionWrapper>
  );
}



/* ---------- Safe Row Component ---------- */

function Row({ label, children }) {

  if (!children) return null;

  return (
    <div className="w-100 border-top">

      <div className="d-flex align-items-start">

        <div className="w-25 bg-white p-3 fw-medium">
          {label}
        </div>

        <div className="w-75 p-3 d-flex flex-wrap gap-2">
          {children}
        </div>

      </div>

    </div>
  );
}

const CompCROServicesSectionWrapper = styled.div`
  .Pill {
    background: white;
    padding: 7px 15px;
    border-radius: 5px;
    font-size: 14px;
    border: 1px solid #eee;
  }
`;


// import React, { useEffect, useState } from 'react';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import BASE_API_URL from "../../apis/index";
// import axios from 'axios';
// import { Button, Link } from '@mui/material';
// import styled from 'styled-components';

// export default function CompServicesSectionCRO({ compId, compName, compTypes }) {
//     const [service, setService] = useState(null);

//     useEffect(() => {
//         async function fetchService() {
//             try {
//                 const authToken = localStorage.getItem("authToken");
//                 const res = await axios.get(
//                     `${BASE_API_URL}/api/seller/company/services/cro/${compId}`,
//                     {
//                         headers: { Authorization: `Bearer ${authToken}` },
//                     }
//                 );

//                 setService(res.data || null);
//             } catch (err) {
//                 console.error("Failed to fetch services", err);
//             }
//         }

//         fetchService();
//     }, [compId]);

//     // ✅ No CRO service exists
//     if (!service) {
//         return (
//             <div className='py-md-5 p-4 bg-light my-4 rounded-4 d-flex align-items-center justify-content-between pb-3 border-bottom'>
//                 <h4 className='fw-normal txt_color_primary'> Services - Contract Research Organisation </h4>
//                 <Link href={`/user-cro-service-register?compId=${compId}&compName=${compName}&types=${encodeURIComponent(JSON.parse(compTypes).join(','))}`}>
//                     <Button variant="outlined" color='primary' size="medium" className="mb-0 shadow-none bg-light">
//                         Register CRO Service
//                     </Button>
//                 </Link>
//             </div>
//         );
//     }

//     return (
//         <CompCROServicesSectionWrapper className="py-md-5 p-5 rounded-5 bg-light my-5">
//             <div className="border rounded-4 overflow-hidden">

//                 {/* Header */}
//                 <div className='d-flex align-items-center justify-content-between px-3 py-4 border-bottom'>
//                     <h5 className="txt_color_primary fw-medium">Services - Contract Research Organisation</h5>

//                     <Link href={`/user-cro-service-edit?servId=${service.id}&compId=${service.company_id}&compName=${compName}`}>
//                         <Button variant="outlined" size="small" className="mb-0 ms-3"> Edit Service </Button>
//                     </Link>
//                 </div>

//                 {/* ✅ Service Catalog */}
//                 <Row label="Service Catalog:">
//                     {service.service_catalog.map((item, i) => (
//                         <div className="Pill" key={i}>{item}</div>
//                     ))}
//                 </Row>

//                 {/* ✅ Geographic Reach */}
//                 <Row label="Geographic Reach:">
//                     {service.geographic_reach.map((item, i) => (
//                         <div className="Pill" key={i}>{item}</div>
//                     ))}
//                 </Row>

//                 {/* ✅ Employee Count */}
//                 <Row label="No of employees in organization:">
//                     {service.employee_count}
//                 </Row>

//                 {/* ✅ QMS Status */}
//                 <Row label="QMS Status:">
//                     <div className="Pill">{service.qms_status === "yes" ? "Yes" : "No"}</div>
//                     {/* ✅ QMS Document */}
//                     {service.qms_status === "yes" && service.qms_file && (
//                         <Button
//                             variant="outlined"
//                             color="warning"
//                             startIcon={<PictureAsPdfIcon />}
//                             href={`${BASE_API_URL}/uploads/user_srvc_docs/${service.qms_file}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             sx={{
//                                 textTransform: 'none',
//                                 borderRadius: '5px',
//                                 padding: '5px 12px',
//                                 fontSize: '14px',
//                             }}
//                         >
//                             View File
//                         </Button>
//                     )}
//                 </Row>


//                 {/* ✅ SOP Following */}
//                 <Row label="SOP Following:">
//                     <div className="Pill">{service.sop_following === "yes" ? "Yes" : "No"}</div>
//                 </Row>

//                 {/* ✅ Past Audit Date */}
//                 {service.past_audit_date && (
//                     <Row label="Past Audit Date:">
//                         {new Date(service.past_audit_date).toLocaleDateString()}
//                     </Row>
//                 )}

//                 {/* ✅ Compliance Statement */}
//                 {service.compliance_statement && (
//                     <Row label="Compliance Statement:">
//                         <div>{service.compliance_statement}</div>
//                     </Row>
//                 )}

//             </div>
//         </CompCROServicesSectionWrapper>
//     );
// }

// // ✅ Reusable Row Component
// function Row({ label, children }) {
//     return (
//         <div className="w-100 border-top">
//             <div className='d-flex align-items-center'>
//                 <div className='w-25 bg-white p-3'>{label}</div>
//                 <div className='w-75 p-2 d-flex flex-wrap gap-2'>
//                     {children}
//                 </div>
//             </div>
//         </div>
//     );
// }

// const CompCROServicesSectionWrapper = styled.div`
//   .Pill {
//     background: white;
//     padding: 7px 15px;
//     border-radius: 5px;
//     font-size: 14px;
//     border: 1px solid #ffffff;
//   }
// `;
